import { AutoCompleteFilters, LoadingListRow } from "SuperAdmin/Components";
import { getAllRoles } from "SuperAdmin/Services/Role";
import { Empty, Radio } from "antd";
import { getSuggestSearchInstitutions } from "Explore/Services/Institution";
import { useEffect, useState } from "react";
import styles from "./CreateRoleForm.module.scss";
import { IconPack } from "SuperAdmin/Config/Icon";
const CreateRoleForm = ({ form, role, setOpenCreateRole, setAddedRole }) => {
  const [data, setData] = useState({ data: [], isLoading: true });
  const [filters, setFilters] = useState({
    type: 1,
    institution_id: null,
  });
  const [pagination, setPagination] = useState({
    page: 1,
    rowsPerPage: 10,
    total: 0,
  });
  const handleChangeType = (value) => {
    setFilters({ ...filters, type: value.target.value });
  };

  useEffect(() => {
    setData({ ...data, isLoading: true });
    getAllRoles(
      pagination.page - 1,
      pagination.rowsPerPage,
      {
        type: filters.type,
        institution_id: filters.institution_id
          ? filters.institution_id[0]
          : null,
      },
      (res) => {
        setData({ data: res.data.roles, isLoading: false });
      }
    );
  }, [filters]);
  const handleAddRole = (item) => {
    form.setFieldsValue({
      role: [...role, { ...item, type: filters.type }],
    });
    setAddedRole({ ...item, type: filters.type });
    setOpenCreateRole(false);
  };
  const Role = ({ item }) => {
    return (
      <div className={styles["role"]}>
        <div>
          <p>
            <b>Management scope: </b>
            {item.management_scope_name
              ? item.management_scope_name
              : "Undefined"}
          </p>
          <div className={styles["permissions"]}>
            {item?.permissions?.map((permission, i) => {
              return <p key={i}>{permission}</p>;
            })}
          </div>
        </div>
        <div className={styles["add-role"]} onClick={() => handleAddRole(item)}>
          {IconPack.add_icon}
        </div>
      </div>
    );
  };

  return (
    <div className={styles["create-role-form"]}>
      <div className={styles["filter-items"]}>
        <p>Type</p>
        <Radio.Group
          onChange={(value) => handleChangeType(value)}
          value={filters.type}
        >
          <Radio value={1}>Institution</Radio>
          <Radio value={2}>Unit</Radio>
        </Radio.Group>
      </div>
      <div className={styles["filter-items"]}>
        <p>Institution</p>
        <AutoCompleteFilters
          placeholder={"Enter to search"}
          functionSearch={getSuggestSearchInstitutions}
          filters={filters}
          setFilters={setFilters}
          entity="institution_id"
          tagColor="blue"
        />
      </div>
      <div className={styles["roles"]}>
        <LoadingListRow
          isLoading={data.isLoading}
          component={
            data.data.length > 0 ? (
              data?.data.map((item, index) => {
                return <Role item={item} key={index} />;
              })
            ) : (
              <Empty description="No Award Found." />
            )
          }
          componentNum={10}
          rows={2}
          avatar={false}
        />
      </div>
    </div>
  );
};

export default CreateRoleForm;
